import { AuthConfigs } from 'Utils/auth/authConfigs';
import { createAxios, getBaseURLController } from './helpers';
const SCOPES = [AuthConfigs.SCOPE_CONTROLLER_API];
class APIUtilities {
    axios;
    constructor(axiosInstance) {
        this.axios = axiosInstance;
    }
    filterNullOrUndefinedParams(params) {
        return Object.fromEntries(Object.entries(params).filter(([, value]) => {
            if (value === null || value === undefined || value === '') {
                return false;
            }
            if (Array.isArray(value) && !value.length) {
                return false;
            }
            return true;
        }));
    }
    listEvents(params) {
        const filteredParams = this.filterNullOrUndefinedParams(params);
        return this.axios.post('/presentation/events/list', filteredParams);
    }
    streamEvents(params) {
        const filteredParams = this.filterNullOrUndefinedParams(params);
        return this.axios.post('/presentation/events/stream', filteredParams);
    }
    postEvent(event) {
        return this.axios.post('/events', event);
    }
    patchEvent(eventId, event) {
        return this.axios.patch(`/events/${eventId}`, event);
    }
    getEventById(eventId) {
        return this.axios.get(`/events/${eventId}`);
    }
    assignAlarmPeriod(eventId, alarmPeriodId) {
        return this.axios.post(`/events/${eventId}/alarm-periods/${alarmPeriodId}`);
    }
    createEventFromAlarmPeriod(alarmPeriodId) {
        return this.axios.post(`/events/from-alarm-period/${alarmPeriodId}`);
    }
    getListEventUsers(params) {
        return this.axios.get('/presentation/events/users', { params });
    }
    streamHierarchy({ onlyActiveModels, onlyWithEvents, onlyWithConfigs, modelOwner }) {
        const data = {};
        data.only_active_models = onlyActiveModels ?? false;
        data.only_with_events = onlyWithEvents ?? false;
        data.only_with_configs = onlyWithConfigs ?? false;
        data.model_owner = modelOwner ?? [];
        return this.axios.post('/presentation/hierarchy/stream_hierarchy', data);
    }
    getHierarchyRoot() {
        return this.axios.get('/presentation/hierarchy/root');
    }
    getModelEntityDetails(modelName) {
        return this.axios.post('/presentation/model_entity/get_details', { model_name: modelName });
    }
    getModelEntityVersionDetails(modelId) {
        return this.axios.post('/presentation/model_entity/get_model_version', { model_id: modelId });
    }
    getModelEntityVersionInputDetails(configId) {
        return this.axios.post('/presentation/model_entity/get_config', { config_id: configId });
    }
    getModelEntitiesShortInfoDetailsByHierarchyIds(sourceNodeIds) {
        return this.axios.post('/presentation/model_entity/get_model_entities', {
            source_node_ids: sourceNodeIds
        });
    }
    getEventOverview(params = {}) {
        const filteredParams = this.filterNullOrUndefinedParams(params);
        return this.axios.get('/presentation/event_overview', { params: filteredParams });
    }
    postFeedback(issue) {
        return this.axios.post('/user_feedback', issue);
    }
}
const api = new APIUtilities(createAxios(SCOPES, getBaseURLController(), 'CONTROLLER_Token'));
export default api;
export { api, APIUtilities };
